<script>
	import { getContext } from "svelte";
  import { fade } from "svelte/transition";
  import { LayerCake, Svg, Html, groupLonger, flatten } from "layercake";
  import { px } from '../../utils'
  import LegendItemScale from "./LegendItemScale.svelte";
  import LegendItemSimple from "./LegendItemSimple.svelte";
  import { colors } from "../../config";

  export let items = [];
  export let paddingTop;

  const formatMillion = value => {
    return value > 1000000 ? `${Math.floor(value/1000000)} Mio.` : value;
  }
</script>

<div class="Legend" style:top={px(paddingTop*-1)}>
  <div class="Legend__inner">
    {#each items as item}
      <div class="Legend__item" transition:fade>
        {#if item === 'fatalitiesScale'}
          <LegendItemScale 
            fill={colors.points}
            suffix=" Opfer"
            width="160px"
            height="52px"
          />
        {:else if item === 'manufacturerScale'}
          <LegendItemScale 
            fill={colors.pointsManufacturers}
            suffix=" Stück"
            formatValue={formatMillion}
            width="200px"
            height="52px"
          />
        {:else if item === 'europeanWeapon'}
          <LegendItemSimple
            fill={colors.pointsHighlighted}
            label="mit europäischen Tatwaffen"
            addMargin=true
          />
        {:else if item === 'europeanManufacturer'}
          <LegendItemSimple
            fill={colors.pointsHighlighted}
            label="mit europäischem Mutterkonzern"
            addMargin=true
          />
        {:else if item === 'otherWeapon'}
          <LegendItemSimple
            fill={colors.points}
            label="mit anderen Tatwaffen"
            addMargin=true
          />
        {:else if item === 'manufacturerAnnotation'}
          <div class="annotation-text">Größe zeigt jährliche Produktionsmenge</div>
        {/if}
      </div>
    {/each}
  </div>
</div>
	

<style lang="scss">
	.Legend {
    position: relative;
    margin: 0 10px;

    @media (max-width: $breakpoint-mobile) {
      transform: translateY(10px);
    }

    &__inner {
      display: flex;
      width: 100%;
      gap: 10px;
      justify-content: center;
    }

    &__item {
      display: flex;
      align-self: center;
      min-height: 57px;
    }
  }

  .annotation-text {
    font-size: 12px;
    line-height: 1.3;
    color: #BDBDBD;
    max-width: 110px;
  }

</style>
